var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
export { TypeaheadOptions };
//# sourceMappingURL=typeahead-options.class.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/typeahead/typeahead-options.class.js
// module id = ../../../../ngx-bootstrap/typeahead/typeahead-options.class.js
// module chunks = 7